import Stack from "@mui/material/Stack";
import { FC, memo } from "react";

import { colors } from "@/theme";

import { ICONS_MAP } from "./data";
import { AppIconProps } from "./type";

export { ICONS_MAP } from "./data";
export type { IconType } from "./type";

const AppIcon: FC<AppIconProps> = ({ name, size = 20, color, ...props }) => {
  const iconSource = ICONS_MAP[name];

  if (!iconSource) {
    console.error(`Icon "${name}" not found.`);

    return null;
  }
  const IconComponent = iconSource;

  return (
    <Stack
      className="app-icon"
      component="span"
      sx={{
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        color: color ? colors[color] : undefined,
        "& svg": {
          width: size,
          height: size,
        },
      }}
      {...props}
    >
      <IconComponent />
    </Stack>
  );
};

export default memo(AppIcon);
